
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/ac6feaa2e398c41f58d48a5d4d5ca1e2.jpg.%20The%20left%20side%20of%20the%20image%20should%20have%20a%20darker%2C%20more%20subdued%20background%20perfect%20for%20text%20overlay%2C%20while%20the%20right%20side%20showcases%20bright%2C%20welcoming%20homes.%20The%20overall%20atmosphere%20should%20convey%20warmth%2C%20security%2C%20and%20the%20dream%20of%20ideal%20living.%20High-quality%20architectural%20photography%20style%20with%20professional%20lighting%20and%20composition.&width=1920&height=1080&seq=hero-real-estate-1&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-4">
        <div className="w-full max-w-4xl">
          <div className="text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              あなたの理想を、<br />
              実現します
            </h1>
            <p className="text-xl md:text-2xl mb-8 opacity-90">
              地域密着型の不動産会社として、<br />
              お客様一人ひとりのライフスタイルに合った<br />
              最適な物件をご提案いたします。
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="text-lg px-8 py-4">
                物件を探す
              </Button>
              <Button variant="outline" size="lg" className="text-lg px-8 py-4 bg-white/10 border-white text-white hover:bg-white hover:text-gray-900">
                査定依頼
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
